import React from 'react'
import PropTypes from 'prop-types'
import Button from '../ui/Button'
import CodeForkIcon from '../ui/icons/CodeForkIcon'

const AddConditionButton = ({ onClick, className }) => (
  <Button variant="neutral" iconNode={<CodeForkIcon />} className={className} onClick={onClick}>
    Ajouter une condition
  </Button>
)

AddConditionButton.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired
}

AddConditionButton.defaultProps = {
  className: ''
}

export default AddConditionButton
